// 從未知型別的例外(通常為 AxiosError 或 Error)安全取出可讀訊息，
// 取代散落各處的 `catch (e: any)` + `e?.response?.data?.detail` 存取。
export function getApiErrorMessage(e: unknown, fallback = '操作失敗'): string {
  if (e && typeof e === 'object') {
    const err = e as {
      response?: { data?: { detail?: unknown; message?: unknown } };
      message?: unknown;
    };
    const apiMsg = err.response?.data?.detail ?? err.response?.data?.message;
    if (typeof apiMsg === 'string' && apiMsg.trim()) return apiMsg;
    if (typeof err.message === 'string' && err.message.trim()) return err.message;
  }
  return fallback;
}
